module.exports = __webpack_public_path__ + "img/auth_enterprise.c936505c.svg";